export function loadClassification(viewer, data){

	if(!data.type || data.type !== "Classification"){
		console.error("分类格式错误!");
		return;
	}
    
	const c = data.classification;

	for (let key in c) {
		if (c.hasOwnProperty(key) && c[key].color) {
			c[key].color = c[key].color.map(value => value / 255);
		}
	}

	viewer.setClassifications(c);

}